import {Bubbles} from '@management-ui/core';
import {withTheme} from '@mui/styles';
import React from 'react';
import withInboxStatuses from './withInboxStatuses';

const InboxStatus = ({message, statuses}) => (
  <Bubbles bubbles={statuses.filter(({key}) => key === message.status).map(({title, colour}) => (
    {
      id: 0,
      label: title,
      colour: colour
    }
  ))}/>
);

export default withInboxStatuses(withTheme(InboxStatus));
